import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { VerdictBadge } from "../components/VerdictBadge";
import { AdSlot } from "../components/AdSlot";
import { motion } from "framer-motion";

export default function Trending() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/trending")
            .then((r) => setItems(r.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16">
            <div className="mb-10 max-w-2xl">
                <p className="text-xs uppercase tracking-widest text-primary mb-3">Trending</p>
                <h1 className="font-display text-4xl md:text-5xl text-accent tracking-tight leading-tight">
                    What the world is fact-checking right now.
                </h1>
            </div>

            {loading ? (
                <p className="text-muted-foreground text-sm">Loading…</p>
            ) : items.length === 0 ? (
                <Card className="card-surface p-10 rounded-2xl text-center text-muted-foreground" data-testid="trending-empty">
                    No trending fact-checks yet. Start one from the homepage.
                </Card>
            ) : (
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {items.map((tc, i) => (
                        <motion.div
                            key={tc.check_id}
                            initial={{ opacity: 0, y: 12 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.35, delay: i * 0.04 }}
                        >
                            <Link
                                to={`/check/${tc.check_id}`}
                                className="card-surface rounded-2xl p-6 block hover:-translate-y-1 transition-transform"
                                data-testid={`trending-item-${i}`}
                            >
                                <VerdictBadge verdict={tc.verdict} confidence={tc.confidence} size="sm" />
                                <p className="mt-4 text-accent font-medium leading-snug line-clamp-3">
                                    &ldquo;{tc.claim}&rdquo;
                                </p>
                                <p className="mt-3 text-xs text-muted-foreground line-clamp-2">{tc.summary}</p>
                                <p className="mt-3 text-[10px] uppercase tracking-widest text-muted-foreground">
                                    {new Date(tc.created_at).toLocaleDateString()}
                                </p>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            )}

            {/* Inline AdSense unit — free-tier monetization, mobile visible. Hidden for Pro & when not configured. */}
            <div className="mt-12">
                <AdSlot slot="inline" format="auto" style={{ minHeight: 90 }} />
            </div>
        </div>
    );
}
